import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import BpcFooter from '@shared/layouts/components/footer/footer.vue';
import BpcSidebar from '@shared/layouts/components/sidebar/sidebar.vue';
import BpcHeader from '@shared/layouts/components/header/header.vue';
import AuthorizationHelper from '@auth/services/authorization.helper';
import PosCheckoutDrawer from '@pos/components/others/pos-checkout-drawer/pos-checkout-drawer.vue';
import ModulesHelper from '@core/services/modules.helper';
import { Invoice } from '@accounting/interfaces/invoice';

library.add(faCog);

@Component({
  name: 'bpc-admin-layout',
  components: {
    BpcHeader,
    BpcSidebar,
    BpcFooter,
    VuePerfectScrollbar,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-pos-checkout-drawer': PosCheckoutDrawer,
  },
})
export default class AdminLayout extends Vue {
  public isConfigOpen: boolean = false;

  /* Lifecycle hooks */
  // created () { }
  mounted() {
    this.listenWebsockets();
    this.getOpenPosSession();
    this.getTerminalsIfActivated();
    this.listenPrintEvents();
  }

  listenPrintEvents() {
    if (window.matchMedia) {
      const mediaQueryList = window.matchMedia('print');
      mediaQueryList.addEventListener('change', async mql => {
        if (mql.matches) {
          // await this.beforePrint();
        } else {
          await this.afterPrint();
        }
      });
    }
  }

  async afterPrint() {
    this.$store.commit('pos/changeIsPrinting', false);
  }

  listenWebsockets() {
    this.$bpcEcho.listenUpdateCenterSettings();
    this.$bpcEcho.listenNewMessages();
  }

  getOpenPosSession() {
    this.$store.dispatch('pos/getOpenPosSession');
  }

  getTerminalsIfActivated() {
    const hasTerminalPaymentsModule = this.$modulesService.hasModuleActivated(
      ModulesHelper.PAYMENT_TERMINALS_MODULE_NAME,
    );

    if (hasTerminalPaymentsModule) {
      this.$store.dispatch('paymentTerminals/getTerminals');
    }
  }

  destroyed() {
    this.$bpcEcho.leaveUpdateCenterSettings();
    this.$bpcEcho.leaveNewMessages();
  }

  public showSidebar(): boolean {
    return this.$authorizationService.hasPermissions([
      AuthorizationHelper.fixedPermissions.sections.main,
      AuthorizationHelper.fixedPermissions.sections.communication,
      AuthorizationHelper.fixedPermissions.sections.configuration,
    ]);
  }
  public getPaddingLeft(): string {
    return this.showSidebar() ? '220px' : '0px';
  }

  get hasOpenPosSession() {
    return !!this.$store.getters['pos/openPosSession'];
  }

  get adminCss() {
    if (this.$store.getters['centerSettings/centerSettings']) {
      return this.$store.getters['centerSettings/centerSettings'].admin_css;
    }
    return null;
  }

  beforeMount() {
    this.appendStyles();
  }

  appendStyles() {
    const css = this.adminCss;
    const head = document.head || document.getElementsByTagName('head')[0];
    const style = document.createElement('style');
    head.appendChild(style);
    style.appendChild(document.createTextNode(css));
  }
}
